import { TableData, TableProps } from './Table';
import { TableHeaderCell } from './TableHeaderCell';
import { TableRow, TableRowProps } from './TableRow';

export type MobileLayoutType = {
  isMobileLayout: boolean;
};

type TableHeaderProps<Data extends TableData> = Required<Pick<TableProps<Data>, 'columns'>> &
  Pick<TableRowProps, 'style'>;

export const TableHeader = <Data extends TableData>({ columns, style }: TableHeaderProps<Data>) => {
  return (
    <TableRow style={style}>
      {columns.map(({ name, label }) => (
        <TableHeaderCell key={String(name)}>{label}</TableHeaderCell>
      ))}
    </TableRow>
  );
};
